import React from 'react';

function Aboutpage() {
    return (
        <div>
            <h1>
                Blance About
            </h1>
        </div>
    )
}

export default Aboutpage;